import NewCalendarDateApp from './NewCalendarDateApp';
import NewCalendarApp from './NewCalendarApp';
import SpecialistCalendarApp from "./SpecialistCalendarApp";
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const NewCalendarAppConfig = {
    auth: [...authRoles.cc, ...authRoles.admin, ...authRoles.adminMedical ], //  ['cc', 'medicalAdmn']
    routes: [
        {
            path: '/apps/new-calendar/:date',
            component: NewCalendarDateApp
        },
        {
            path: '/apps/new-calendar',
            component: NewCalendarApp
        },
        {
            path: '/apps/specialist-mission',
            component: SpecialistCalendarApp
        },
        {
            path: '/apps/institution-specialist',
            component: SpecialistCalendarApp
        },
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/NewCalendarAppConfig.js